const EmailTab = (props) => {
  const tabData = [
    { id: "EmailScheduled", title: "Email Template" },
    { id: "email", title: "Email To Attendee List" },
  ];

  return (
    <nav className="event-settings-email-tabs" aria-label="Email sections">
      {tabData.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`event-settings-email-tab${
            props.Id === tab.id ? " is-active" : ""
          }`}
          onClick={() => props.ClickHandler(tab.id)}
        >
          {tab.title}
        </button>
      ))}
    </nav>
  );
};

export default EmailTab;
